import { render, staticRenderFns } from "./tit-quarternary.vue?vue&type=template&id=b6058116&scoped=true&"
import script from "./tit-quarternary.vue?vue&type=script&lang=js&"
export * from "./tit-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6058116",
  null
  
)

export default component.exports